import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var colorCurveToHex = function colorCurveToHex(_ref) {
  var _ref2 = _slicedToArray(_ref, 4),
    r = _ref2[0],
    g = _ref2[1],
    b = _ref2[2],
    a = _ref2[3];
  var hex = function hex(x) {
    var value = Math.round(x * 255).toString(16).toUpperCase();
    if (value.length < 2) {
      return "0".concat(value);
    }
    return value;
  };
  var rgb = "#".concat(hex(r)).concat(hex(g)).concat(hex(b));
  if (a !== 1) {
    return "".concat(rgb).concat(hex(a));
  }
  return rgb;
};
var COLORCURVE_SECURITY = [[0.553, 0.196, 0.392, 1], [0.451, 0.125, 0.125, 1], [0.737, 0.067, 0.09, 1], [0.808, 0.267, 0.059, 1], [0.863, 0.427, 0.027, 1], [0.961, 1, 0.514, 1], [0.447, 0.906, 0.333, 1], [0.38, 0.859, 0.643, 1], [0.306, 0.808, 0.973, 1], [0.227, 0.604, 0.922, 1], [0.173, 0.459, 0.886, 1]];
var SecurityStatusColors = {
  "0": colorCurveToHex(COLORCURVE_SECURITY[0]),
  "1": colorCurveToHex(COLORCURVE_SECURITY[1]),
  "2": colorCurveToHex(COLORCURVE_SECURITY[2]),
  "3": colorCurveToHex(COLORCURVE_SECURITY[3]),
  "4": colorCurveToHex(COLORCURVE_SECURITY[4]),
  "5": colorCurveToHex(COLORCURVE_SECURITY[5]),
  "6": colorCurveToHex(COLORCURVE_SECURITY[6]),
  "7": colorCurveToHex(COLORCURVE_SECURITY[7]),
  "8": colorCurveToHex(COLORCURVE_SECURITY[8]),
  "9": colorCurveToHex(COLORCURVE_SECURITY[9]),
  "10": colorCurveToHex(COLORCURVE_SECURITY[10])
};
export { SecurityStatusColors };